import React, { useEffect, useState } from 'react';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-material-ui';
import { DatePicker, DateTimePicker } from 'formik-material-ui-pickers';
import * as Yup from 'yup';
import { Grid, Paper } from '@material-ui/core';

interface CalibrationFormValues {
  calibration_date: Date | null;
  AmbientTemperature: string;
  AmbientHumidity: string;
}
export const CalibrationForm = ({ onSubmit }: { onSubmit: (data: any) => void }) => {

  const [formData, setFormData] = useState<CalibrationFormValues>({
    calibration_date: null,
    AmbientTemperature: '',
    AmbientHumidity: '',
  });

  return (
    <Paper elevation={2} style={{ padding: 16, marginBottom: 16 }}>
      <Formik
        initialValues={formData}
        enableReinitialize
        validationSchema={Yup.object({
          calibration_date: Yup.date()
            .nullable()
            .required('Calibration date is required'),
          AmbientTemperature: Yup.string()
            .required('Ambient Temperature is required'),
          AmbientHumidity: Yup.string()
            .required('Ambient Humidity is required'),
        })}
        
        onSubmit={(values) => {
          setFormData(values);
          const formattedDate = values.calibration_date
            ? new Date(values.calibration_date).toISOString().split("T")[0]
            : null;

          onSubmit({
            ...values,
            calibration_date: formattedDate,
          });
        }}

      >
        {({ values, errors, touched, isValid, submitForm }) => {

          useEffect(() => {
            const debounceTimeout = setTimeout(() => {
              if (
                values.calibration_date &&
                values.AmbientTemperature &&
                values.AmbientHumidity &&
                isValid
              ) {
                submitForm();
              }
            }, 1500);

            return () => clearTimeout(debounceTimeout);
          }, [values, isValid, submitForm]);

          return (
            <Form>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  

                  <Field
                    name="calibration_date"
                    component={DateTimePicker}
                    format="YYYY-MM-DD"
                    
                    label="Calibration Date"
                    inputVariant="outlined"
                    data-testid="CalibrationDate"

                  />
                </Grid>
                <Grid item xs={4}>
                  <Field
                    name="AmbientTemperature"
                    component={TextField}
                    label="Ambient Temperature"
                    variant="outlined"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={4}>
                  <Field
                    name="AmbientHumidity"
                    component={TextField}
                    label="Ambient Humidity"
                    variant="outlined"
                    fullWidth
                  />
                </Grid>
              </Grid>


            </Form>
          )
        }}
      </Formik>
    </Paper>
  );
};
